var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"IndexTemisCivil_div"}},[_c('MenuSuperior',{attrs:{"titulo":"DH","subtitulo":"Herramienta para Conteo de Días Hábiles"}}),_vm._v(" "),_c('MenuIzquierda'),_vm._v(" "),_c('div',{staticClass:"content-area"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-047c4e2c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DiasHabiles/Comun/Plantilla.vue
// module id = null
// module chunks = 